import React from 'react';
import { Mail } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SUPPORT_EMAIL } from '@/lib/support';
import Icon from './Icon';

/**
 * Email support card (Figma "Contact card", Email). Email is for general questions only —
 * claims are filed on the dashboard or WhatsApp, so never present email as a claim channel.
 */
const EmailContactCard: React.FC<{ className?: string }> = ({ className }) => (
  <section className={cn('tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-p-[18px]', className)}>
    <span className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-ds-subtle tw-text-ds-text-primary">
      <Icon icon={Mail} size={20} />
    </span>
    <div className="tw-flex tw-flex-col tw-gap-0.5">
      <h2 className="tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-ds-text-primary">Email us</h2>
      <p className="tw-text-[13px] tw-leading-[18px] tw-text-ds-text-secondary">For general questions. We reply within 24 hours.</p>
    </div>
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      className="tw-self-start tw-rounded tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-ds-brand-text hover:tw-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ds-brand"
    >
      {SUPPORT_EMAIL}
    </a>
  </section>
);

export default EmailContactCard;
